import { SapExportStatus } from "@/api-schema-enums";
import { ReactElement } from "react";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export class SapExportStatusFilter extends Filter<{ exportStatus?: SapExportStatus[] }, Record<string, never>> {
  readonly id: string = "exportStatus";
  readonly labelSingular = "masterdata:SapExportStatus";
  readonly labelPlural = "masterdata:SapExportStatus";
  readonly placeholder = "masterdata:SelectSapExportStatus";
  readonly searchPlaceholder = "masterdata:SearchSapExportStatus";
  readonly emptyText = "masterdata:NoSapExportStatusFound";
  body = {};
  parameters = {};

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    return {
      options: [
        { id: SapExportStatus.SUCCESS, name: "masterdata:SapExportStatusSuccess" },
        { id: SapExportStatus.FAILED, name: "masterdata:SapExportStatusFailed" },
      ],
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): ReactElement {
    return <FilterComponent filter={this} {...props} />;
  }
}
